<template>
  <div class="sn-union-left">
    <div class="header logo">
      <img
        src="../../assets/images/logo-02.png"
        alt=""
      >
      <a
        href="http://www.suning.com"
        class="suning-logo"
      ></a>
      <a
        href="/"
        class="union-logo"
      ></a>
    </div>
    <div class="union-nav">
      <dl
        v-for="(item, index) in leftMenuConfig"
        :key="item.name"
        :class="[item.selected ? 'selected' : '']"
        @click="showModule(index)"
      >
        <dt>
          <div>
            <i :class="item.icon"></i>
            <span>{{item.name}}</span>
            <i class="icon-arrow"></i>
          </div>
        </dt>
        <div class="dd-ctn">
          <dd
            v-for="itemy in item.children"
            :class="[itemy.selected ? 'selected' : '']"
            :key="itemy.name"
          >
            <a :href="itemy.href">{{itemy.name}}</a>
          </dd>
        </div>
      </dl>
    </div>
  </div>
</template>

<script>
import { leftMenuConfig, leftMenuConfigOpen } from "./config";
import _ from 'lodash'
export default {
  name: 'LeftMenu',
  data() {
    return {
      selectedNum: 0,
      leftMenuConfig: []
    };
  },
  methods: {
    showModule(index) {
      let elementDl = document.querySelectorAll('.union-nav dl');
      let elementDd = document.querySelectorAll('.union-nav dl .dd-ctn');
      let selectedIndex = -1   //已选中索引
      Array.prototype.slice.call(elementDl).forEach((item,key) => {
        item.classList.contains('selected') && (selectedIndex = key)
      })
      if(index === selectedIndex){
        elementDd[index].style.height = this.setHeight(index)
        this.toggleSlide(elementDd[index], 0, this.setTime(index))
        setTimeout(() => elementDl[index].classList.remove('selected'), this.setTime(index));
      }else {
        if(selectedIndex !== -1) {
          this.toggleSlide(elementDd[selectedIndex], 0, this.setTime(selectedIndex))
          setTimeout(() => {
            elementDl[selectedIndex].classList.remove('selected')
          }, this.setTime(selectedIndex));
        }   
        elementDl[index].classList.add('selected')
        elementDd[index].style.height = 0
        setTimeout(() => {
          this.toggleSlide(elementDd[index], this.setHeight(index), this.setTime(index))
        }, 0)    
      }
    },
    toggleSlide(dom, height, time) {
      dom.style.transition = "height " + time + "ms";
      dom.style.height = height + "px";
    },
    setTime(index) {
      if(index === -1){
        return 0
      }else {
        return this.leftMenuConfig[index].children.length*16.7*2;
      }
    },
    setHeight(index) {
      return this.leftMenuConfig[index].children.length * 38
    }
  },
  created() {
    this.leftMenuConfig = _.cloneDeep(process.env.VUE_APP_Platform == "1" ? leftMenuConfigOpen : leftMenuConfig);
  },
  mounted () {
    let self = this
    let elementDd = document.querySelectorAll('.union-nav dl .dd-ctn');
    self.leftMenuConfig.forEach((item, index) => {
      if(item.selected){
        this.toggleSlide(elementDd[index], self.setHeight(index), self.setTime(index))
      }
    })
  }
};
</script>

<style lang="scss" scoped>
.union-nav dl {
  overflow: hidden;
}
</style>